import { useUserInfoStore } from '@/stores/user-info'
import { removeToken } from '@/utils/token/index'
import { useRouter } from 'vue-router'
import { computed } from 'vue'
import { accountApi } from '@/api/account'

export const useLogout = () => {
  const router = useRouter()
  const store = useUserInfoStore()
  // 格式化手机号显示
  const formatMobileStr = computed(() => {
    const mobile = store.userInfo?.mobile || ''
    const str1 = mobile.substring(0, 3)
    const str2 = mobile.substring(7)
    return `${str1}****${str2}`
  })

  // 推出按钮点击事件
  const handleLogout = async () => {
    removeToken()
    try {
      await accountApi.loginOut()
    } catch (e) {
      console.warn('handleLogout', e)
    }
    router.push('/login')
  }

  const handleShowUserCenter = () => {
    store.setShowUserCenter(true)
  }
  return {
    formatMobileStr,
    handleLogout,
    handleShowUserCenter,
    userInfo: computed(() => store.userInfo)
  }
}
